import React from "react";
import ReactDOM from "react-dom";

import { IToolFacet } from "types";

import { ToolQuickSearchContainer } from "./containers";

(() => {
  const toolQuickSearchContainers = document.querySelectorAll<HTMLElement>(
    "[data-tool-quick-search]"
  );

  if (!toolQuickSearchContainers) return;

  toolQuickSearchContainers.forEach((toolQuickSearchContainer) => {
    const data = toolQuickSearchContainer.dataset.toolQuickSearch;
    toolQuickSearchContainer.dataset.toolQuickSearch = ""; //cleanup

    if (!data) return;

    const toolQuickSearchData = JSON.parse(data) as IToolFacet[];

    ReactDOM.render(
      <ToolQuickSearchContainer facets={toolQuickSearchData} />,
      toolQuickSearchContainer
    );
  });
})();
